import React from 'react';
import { TextField } from '../../../atom/TextField';
import { TextArea } from '../../../atom/TextArea';
import { SelectField } from '../../../atom/SelectField';
import removeIcon from '../../../../assets/images/icons/removeFile.svg';

const InquiryFields = ({ selectedRow,
  currentCategories,
  formatDate,
  stripHtmlAndFormat,
  getCategoryValue,
  transformCategoryOptions,
  handleRemoveImage,
  handleAddImage,
  filesToUpload = {},
  filesToDelete = {},
  API_URL,
  partners = [],
  getPartnerValue,
  transformPartnerOptions,
  products = [],
  getProductValue,
  transformProductOptions }) => {
  return (
    <>
      {/* inquiry */}
      <TextField name="title" label="Titel" value={selectedRow.title} type="text" permission="view-only" clName="full-col"/>
      <TextField name="first_name" label="Dit fornavn" value={selectedRow.first_name} type="text" permission="edit" clName="half-col"/>
      <TextField name="last_name" label="Dit efternavn" value={selectedRow.last_name} type="text" permission="edit" clName="half-col"/>
      <TextArea name="full_address" label="Fulde adresse" value={stripHtmlAndFormat(selectedRow.full_address)} permission="edit" clName="full-col" rows={4}/>
      {currentCategories.housing_type && (
        <SelectField 
          name="housing_type"
          label="Boligtype" 
          value={getCategoryValue('housing_type', currentCategories.housing_type)} 
          permission="edit" 
          clName="full-col"
          options={transformCategoryOptions(currentCategories.housing_type, 'Boligtype')}
        />
      )}
      <TextField name="phone_number" label="Dit telefon nr" value={selectedRow.phone_number} type="phone" permission="edit" clName="half-col"/>
      <TextField name="email" label="Din Email" value={selectedRow.email} type="email" permission="edit" clName="half-col"/>
      <TextField name="task_postal_code" label="Postnummer, hvor opgaven skal udføres" value={selectedRow.task_postal_code} type="text" permission="edit" clName="full-col"/>
 <TextArea name="task_description" label="Beskrivelse af opgaven" value={stripHtmlAndFormat(selectedRow.task_description)} permission="edit" clName="full-col" rows={4}/>
      <TextArea name="task_start_preferred_date" label="Hvornår ønskes opgaven udført?" value={stripHtmlAndFormat(selectedRow.task_start_preferred_date)} permission="edit" clName="full-col" rows={4}/>
      <TextField name="agreed_followup" label="Aftalt opfølgning" value={formatDate(selectedRow.agreed_followup)} type="date" permission="edit" clName="full-col"/>
      {currentCategories.followup_status && (
        <SelectField 
          name="followup_status"
          label="Status på opfølgning" 
          value={getCategoryValue('followup_status', currentCategories.followup_status)} 
          permission="edit" 
          clName="full-col"
          options={transformCategoryOptions(currentCategories.followup_status, 'Status på opfølgning')}
        />
      )}
      <TextArea name="subcontractor_conversation_note" label="UE kommentar til samtalen" value={stripHtmlAndFormat(selectedRow.subcontractor_conversation_note)} permission="edit" clName="full-col" rows={4}/>
      <TextArea name="conversation_comment" label="Kommentar til samtalen" value={stripHtmlAndFormat(selectedRow.conversation_comment)} permission="edit" clName="full-col" rows={4}/>
      <div className="wrapper-group">
        <label>Besigtigelsesdato</label>
        <TextField name="inspection_date_start" value={formatDate(selectedRow.inspection_date_start)} type="date" permission="edit" clName="half-col"/>
        <TextField name="inspection_date_end" value={formatDate(selectedRow.inspection_date_end)} type="date" permission="edit" clName="half-col"/>
      </div>
      
       {currentCategories.status && (
        <SelectField 
          name="status"
          label="Status" 
          value={getCategoryValue('status', currentCategories.status)} 
          permission="edit" 
          clName="full-col"
          options={transformCategoryOptions(currentCategories.status, 'Status', false)}
        />
      )}
      {currentCategories.painterkanon_employee && (
        <SelectField 
          name="painterkanon_employee"
          label="MalerKanon medarbejder" 
          value={getCategoryValue('painterkanon_employee', currentCategories.painterkanon_employee)} 
          permission="edit" 
          clName="full-col"
          options={transformCategoryOptions(currentCategories.painterkanon_employee, 'MalerKanon medarbejder')}
        />
      )}
       {currentCategories.region && (
        <SelectField 
          name="region"
          label="Landsdel" 
          value={getCategoryValue('region', currentCategories.region)} 
          permission="edit" 
          clName="full-col"
          options={transformCategoryOptions(currentCategories.region, 'Landsdel')}
        />
      )}
       <TextField name="gk_service_manager" label="GK Service-manager" value={selectedRow.gk_service_manager} type="text" permission="view-only" clName="half-col"/>
       <TextField name="gk_total_price" label="GK Pris for opgaven inkl. moms." value={selectedRow.gk_total_price} type="text" permission="view-only" clName="half-col"/>
       <TextField name="gk_discounted_price" label="GK Discounted Price" value={selectedRow.gk_discounted_price} type="number" permission="view-only" clName="full-col"/>
       <TextArea name="gk_full_address" label="GK Fulde adresse" value={stripHtmlAndFormat(selectedRow.gk_full_address)} permission="view-only" clName="full-col" rows={4}/>
       {currentCategories.floor_cannon_employee && (
        <SelectField 
          name="floor_cannon_employee"
          label="GulvKanon medarbejder" 
          value={getCategoryValue('floor_cannon_employee', currentCategories.floor_cannon_employee)} 
          permission="view-only" 
          clName="full-col"
          options={transformCategoryOptions(currentCategories.floor_cannon_employee, 'GulvKanon medarbejder')}
        />
      )}
      {currentCategories.gk_rooms_to_sand && (
        <SelectField 
          name="gk_rooms_to_sand"
          label="GK Antal rum der skal slibes" 
          value={getCategoryValue('gk_rooms_to_sand', currentCategories.gk_rooms_to_sand)} 
          permission="view-only" 
          clName="full-col"
          options={transformCategoryOptions(currentCategories.gk_rooms_to_sand, 'GK Antal rum der skal slibes')}
        />
      )}
      <TextField name="area_sqm" label="Antal m2" value={selectedRow.area_sqm} type="number" permission="view-only" clName="half-col"/>
      <TextField name="number_of_m_two_planing" label="Antal m2 afhøvling" value={selectedRow.number_of_m_two_planing} type="number" permission="view-only" clName="half-col"/>
      <TextField name="stairs_count" label="Antal trappetrin" value={selectedRow.stairs_count} type="number" permission="view-only" clName="half-col"/>
      <TextField name="performed_in_two_stages" label="Udføres over 2 gange" value={selectedRow.performed_in_two_stages} type="number" permission="view-only" clName="half-col"/>
      <TextArea name="task_based_on_invoice" label="Opgave baseret på (Til faktura)" value={selectedRow.task_based_on_invoice && selectedRow.task_based_on_invoice !== null && selectedRow.task_based_on_invoice !== 'null' ? stripHtmlAndFormat(selectedRow.task_based_on_invoice) : ''} permission="view-only" clName="full-col" rows={4}/>
      <TextArea name="task_description_invoice" label="Opgavebeskrivelse (På faktura)" value={stripHtmlAndFormat(selectedRow.task_description_invoice)} permission="view-only" clName="full-col" rows={4}/>
      <TextField name="offer_section" label="TILBUDS SEKTION" value={selectedRow.offer_section} type="text" permission="view-only" clName="full-col"/>
      <TextArea name="task_description_offer_pdf" label="Opgavebeskrivelse (til Faktura) (Til tilbuds PDF)" value={stripHtmlAndFormat(selectedRow.task_description_offer_pdf)} permission="edit" clName="full-col" rows={4}/>
      <TextField name="task_price_estimate" label="Pris for opgaven inkl. moms. Prisoverslag" value={selectedRow.task_price_estimate} type="number" permission="edit" clName="half-col"/>
      <TextField name="hourly_rate" label="Timepris inkl. moms (vises ikke på faktura)" value={selectedRow.hourly_rate} type="number" permission="edit" clName="half-col"/>
      <TextField name="estimated_hours" label="Estimeret timeforbrug (vises ikke på faktura)" value={selectedRow.estimated_hours} type="number" permission="edit" clName="half-col"/>
      <TextField name="estimate_sent_date" label="Prisoverslag Sendt DATO" value={formatDate(selectedRow.estimate_sent_date)} type="date" permission="edit" clName="half-col"/>
      <TextField name="offer_sent_date" label="Tilbud sendt/afgivet DATO" value={formatDate(selectedRow.offer_sent_date)} type="date" permission="edit" clName="half-col"/>
      {products && products.length > 0 && (
        <SelectField 
          name="add_product"
          label="Tilføj produkt (Vælg ét produkt ad gangen)" 
          value={getProductValue ? getProductValue() : ''} 
          permission="edit" 
          clName="half-col"
          options={transformProductOptions ? transformProductOptions() : [{ value: '', label: 'Vælg produkt' }]}
        />
      )}
      <TextField name="price_for_the_task" label="Pris for opgaven inkl. moms. (Til tilbuds PDF)" value={selectedRow.price_for_the_task} type="number" permission="edit" clName="half-col"/>
      <TextField name="estimated_days" label="Estimeret tid for opgaven - dage (Til tilbuds PDF)" value={selectedRow.estimated_days} type="text" permission="edit" clName="half-col"/>
      <TextArea name="additional_services_text" label="Fritekst til ekstraydelser (Til tilbuds PDF)" value={stripHtmlAndFormat(selectedRow.additional_services_text)} permission="edit" clName="full-col" rows={4}/>
      <TextArea name="not_included_in_offer" label="Ikke inkluderet i tilbuddet (Tekst til kunde PDF)" value={stripHtmlAndFormat(selectedRow.not_included_in_offer)} permission="edit" clName="full-col" rows={4}/>
      <TextArea name="free_of_charge" label="Uden beregning (Tekst til kunde PDF)" value={stripHtmlAndFormat(selectedRow.free_of_charge)} permission="edit" clName="full-col" rows={4}/>
      <TextField name="offer_section_2" label="TILBUDS SEKTION" value={selectedRow.offer_section_2} type="text" permission="view-only" clName="full-col"/>
      <TextArea name="task_description_offer2" label="Opgavebeskrivelse (til Faktura) (Tilbud 2)" value={stripHtmlAndFormat(selectedRow.task_description_offer2)} permission="edit" clName="full-col" rows={4}/>
      <TextField name="offer_price_2" label="Pris for opgaven inkl. moms. (Tilbud 2)" value={formatDate(selectedRow.offer_price_2)} type="number" permission="edit" clName="half-col"/>
      <TextField name="offer_sent_date_2" label="Tilbud sendt/afgivet DATO (Tilbud 2)" value={formatDate(selectedRow.offer_sent_date_2)} type="date" permission="edit" clName="half-col"/>
      <TextArea name="additional_info" label="Supplerende info" value={stripHtmlAndFormat(selectedRow.additional_info)} permission="edit" clName="full-col" rows={4}/>
      {currentCategories.floor_area_size && (
        <SelectField 
          name="floor_area_size"
          label="Størrelse gulvareal" 
          value={getCategoryValue('floor_area_size', currentCategories.floor_area_size)} 
          permission="view-only" 
          clName="full-col"
          options={transformCategoryOptions(currentCategories.floor_area_size, 'Størrelse gulvareal')}
        />
      )}
      {currentCategories.rooms_to_paint && (
        <SelectField 
          name="rooms_to_paint"
          label="Antal rum der skal males" 
          value={getCategoryValue('rooms_to_paint', currentCategories.rooms_to_paint)} 
          permission="edit" 
          clName="full-col"
          options={transformCategoryOptions(currentCategories.rooms_to_paint, 'Antal rum der skal males')}
        />
      )}
       {currentCategories.price && (
        <SelectField 
          name="price"
          label="Pris" 
          value={getCategoryValue('price', currentCategories.price)} 
          permission="view-only" 
          clName="full-col"
          options={transformCategoryOptions(currentCategories.price, 'Pris')}
        />
      )}
      <TextField name="mk_standard_offer_price_text" label="Tekst MK Std. Tilbudspris" value={selectedRow.mk_standard_offer_price_text} type="text" permission="view-only" clName="full-col"/>
      {currentCategories.partner_trigger && (
        <SelectField 
          name="partner_trigger"
          label="Partner (OBS - TRIGGER FLOWS)" 
          value={getCategoryValue('partner_trigger', currentCategories.partner_trigger)} 
          permission="view-only" 
          clName="full-col"
          options={transformCategoryOptions(currentCategories.partner_trigger, 'Partner')}
        />
      )}
       {partners && partners.length > 0 && (
         <SelectField 
           name="partner"
           label="Partner" 
           value={getPartnerValue ? getPartnerValue() : ''} 
           permission="edit" 
           clName="full-col"
           options={transformPartnerOptions ? transformPartnerOptions() : []}
         />
       )}
       <TextField name="price_evaluation" label="PRIS EVALUERING" value={selectedRow.price_evaluation} type="text" permission="view-only" clName="half-col"/>
       <TextField name="material_cost" label="Materiale udgift i kr." value={selectedRow.material_cost} type="number" permission="view-only" clName="half-col"/>
       <TextField name="trigger_price_evaluation" label="Trigger Pris Evaluering" value={selectedRow.trigger_price_evaluation} type="text" permission="view-only" clName="full-col"/>
       <TextField name="calc_price_for_painter" label="OutPut: Udregning af pris til maler" value={selectedRow.calc_price_for_painter} type="text" permission="view-only" clName="half-col"/>
       <TextField name="painter_final_price" label="Malerens endelige pris" value={selectedRow.painter_final_price} type="number" permission="view-only" clName="half-col"/>
       <TextField name="calc_price_for_painter_input" label="Udregning af pris til maler [Flow input]" value={selectedRow.calc_price_for_painter_input} type="number" permission="view-only" clName="full-col"/>
       {currentCategories.revenue_per_hour && (
        <SelectField 
          name="revenue_per_hour"
          label="OutPut: Omsætning pr time" 
          value={getCategoryValue('revenue_per_hour', currentCategories.revenue_per_hour)} 
          permission="view-only" 
          clName="full-col"
          options={transformCategoryOptions(currentCategories.revenue_per_hour, 'Omsætning pr time')}
        />
      )}
       {currentCategories.output_material_cost && (
        <SelectField 
          name="output_material_cost"
          label="OutPut: Materialeudgift" 
          value={getCategoryValue('output_material_cost', currentCategories.output_material_cost)} 
          permission="view-only" 
          clName="full-col"
          options={transformCategoryOptions(currentCategories.output_material_cost, 'Materialeudgift')}
        />
      )}
      {currentCategories.output_employee_salary_cost && (
        <SelectField 
          name="output_employee_salary_cost"
          label="OutPut: Medarb. Lønudgift" 
          value={getCategoryValue('output_employee_salary_cost', currentCategories.output_employee_salary_cost)} 
          permission="view-only" 
          clName="full-col"
          options={transformCategoryOptions(currentCategories.output_employee_salary_cost, 'Medarb. Lønudgift')}
        />
      )}
      <div className="wrapper-group">
        <label>Udførelsesdato</label>
        <TextField name=" execution_date_start" value={formatDate(selectedRow.execution_date_start)} type="date" permission="view-only" clName="half-col"/>
        <TextField name="execution_date_end" value={formatDate(selectedRow.execution_date_end)} type="date" permission="view-only" clName="half-col"/>
      </div>
       
       {/* 1. ENGELSK? - View */}
       {currentCategories.is_english && (
        <SelectField 
          name="is_english"
          label="ENGELSK?" 
          value={getCategoryValue('is_english', currentCategories.is_english)} 
          permission="view-only" 
          clName="full-col"
          options={transformCategoryOptions(currentCategories.is_english, 'ENGELSK')}
        />
      )}
       
       {/* 2. Vedhæft billeder - View */}
       {/* 4. Vedhæft billeder from Billede modtagelse - View */}
       {/* 5. Billeder fra maler inden opstart - Edit */}
       {/* Display Images from files object - Static sections for each field */}
       {(selectedRow.files !== undefined || Object.keys(filesToUpload).length > 0) && (
        <div className="form-group full-col">
          <div className="uploads-image">
            {/* Helper function to render a single field section */}
            {(() => {
              const renderFieldSection = (fieldName, customLabel) => {
                const existingFiles = selectedRow.files?.[fieldName] || [];
                const pendingFiles = filesToUpload[fieldName] || [];
                const deletedFileIds = filesToDelete[fieldName] || [];
                
                // Check if this is a partner image field (only partner images can be edited)
                const isPartnerImageField = fieldName === 'images-from-partners';
                
                // Filter only image files from existing files, excluding deleted ones
                const imageFiles = existingFiles.filter(file => {
                  if (!file) return false;
                  const filename = file.filename || '';
                  const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.bmp', '.svg'];
                  const isImage = imageExtensions.some(ext => filename.toLowerCase().endsWith(ext));
                  const isDeleted = file.file_id && deletedFileIds.includes(file.file_id);
                  return isImage && !isDeleted;
                });
                
                // Create preview URLs for pending uploads
                const pendingImageFiles = pendingFiles.map((file, index) => ({
                  file: file,
                  previewUrl: URL.createObjectURL(file),
                  name: file.name,
                  isPending: true,
                  index: index
                }));
                
                const allImages = [...imageFiles, ...pendingImageFiles];
                
                // Only render if there are files or pending uploads for this field
                if (allImages.length === 0 && !selectedRow.files?.[fieldName] && !filesToUpload[fieldName]) {
                  return null;
                }
              
                return (
                  <div key={fieldName} className="image-field-wrapper">
                    <div className="label">
                      {customLabel || fieldName.replace(/-/g, ' ').charAt(0).toUpperCase() + fieldName.replace(/-/g, ' ').slice(1).toLowerCase()}
                    </div>
                    <div className="uploads-image__wrap">
                      {allImages.map((item, index) => {
                        const isPending = item.isPending;
                        const imageUrl = isPending ? item.previewUrl : item.previewUrl;
                        const fileId = isPending ? null : item.file_id;
                        const fileName = isPending ? item.name : (item.filename || '');
                        const isLastImage = index === allImages.length - 1;
                        const removeIndex = isPending ? item.index : index;
                        
                        return (
                          <React.Fragment key={`${fieldName}-${isPending ? `pending-${removeIndex}` : (fileId || index)}`}>
                            <div className={`image-wrapper ${isPending ? 'pending-upload' : ''}`}>
                              <div className="image">
                                {isPending && <div className="pending-badge">New</div>}
                                {/* Only show remove button for partner images */}
                                {isPartnerImageField && (
                                  <button
                                    className="image-remove-btn"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleRemoveImage(fieldName, fileId, removeIndex);
                                    }}
                                    type="button"
                                    title="Remove image"
                                  >
                                    <img src={removeIcon} alt="Remove" />
                                  </button>
                                )}
                                <img
                                  src={imageUrl}
                                  alt={fileName}
                                  loading="lazy"
                                  onError={(e) => {
                                    e.target.style.display = 'none';
                                  }}
                                />
                              </div>
                            </div>
                            {/* Only show add button for partner images and only on last image */}
                            {isLastImage && isPartnerImageField && (
                              <div className="image-add-wrapper">
                                <button
                                  className="image-add-btn"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleAddImage(fieldName);
                                  }}
                                  type="button"
                                  title="Add image"
                                >
                                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <line x1="12" y1="5" x2="12" y2="19"></line>
                                    <line x1="5" y1="12" x2="19" y2="12"></line>
                                  </svg>
                                </button>
                              </div>
                            )}
                          </React.Fragment>
                        );
                      })}
                      {/* Show add button if no images exist - only for partner images */}
                      {allImages.length === 0 && isPartnerImageField && (
                        <div className="image-add-wrapper">
                          <button
                            className="image-add-btn"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleAddImage(fieldName);
                            }}
                            type="button"
                            title="Add image"
                          >
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                              <line x1="12" y1="5" x2="12" y2="19"></line>
                              <line x1="5" y1="12" x2="19" y2="12"></line>
                            </svg>
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                );
              };
              
              return (
                <>
                  {/* 2. Vedhæft billeder - View */}
                  {renderFieldSection('vedhaeft-billeder', 'Vedhæft Billeder')}
                </>
              );
            })()}
          </div>
        </div>
      )}
      
       {/* 3. Øvrige billeder vedhæftet fra webside - View */}
       <TextArea name="other_images_from_website" label="Øvrige billeder vedhæftet fra webside" value={stripHtmlAndFormat(selectedRow.other_images_from_website)} permission="view-only" clName="full-col" rows={4}/>
       
       {/* 4. Vedhæft billeder from Billede modtagelse - View */}
       {/* 5. Billeder fra maler inden opstart - Edit */}
       {/* Display Images from files object - Static sections for each field */}
       {(selectedRow.files !== undefined || Object.keys(filesToUpload).length > 0) && (
        <div className="form-group full-col">
          <div className="uploads-image">
            {/* Helper function to render a single field section */}
            {(() => {
              const renderFieldSection = (fieldName, customLabel) => {
                const existingFiles = selectedRow.files?.[fieldName] || [];
                const pendingFiles = filesToUpload[fieldName] || [];
                const deletedFileIds = filesToDelete[fieldName] || [];
                
                // Check if this is a partner image field (only partner images can be edited)
                const isPartnerImageField = fieldName === 'images-from-partners';
                
                // Filter only image files from existing files, excluding deleted ones
                const imageFiles = existingFiles.filter(file => {
                  if (!file) return false;
                  const filename = file.filename || '';
                  const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.bmp', '.svg'];
                  const isImage = imageExtensions.some(ext => filename.toLowerCase().endsWith(ext));
                  const isDeleted = file.file_id && deletedFileIds.includes(file.file_id);
                  return isImage && !isDeleted;
                });
                
                // Create preview URLs for pending uploads
                const pendingImageFiles = pendingFiles.map((file, index) => ({
                  file: file,
                  previewUrl: URL.createObjectURL(file),
                  name: file.name,
                  isPending: true,
                  index: index
                }));
                
                const allImages = [...imageFiles, ...pendingImageFiles];
                
                // Only render if there are files or pending uploads for this field
                if (allImages.length === 0 && !selectedRow.files?.[fieldName] && !filesToUpload[fieldName]) {
                  return null;
                }
              
                return (
                  <div key={fieldName} className="image-field-wrapper">
                    <div className="label">
                      {customLabel || fieldName.replace(/-/g, ' ').charAt(0).toUpperCase() + fieldName.replace(/-/g, ' ').slice(1).toLowerCase()}
                    </div>
                    <div className="uploads-image__wrap">
                      {allImages.map((item, index) => {
                        const isPending = item.isPending;
                        const imageUrl = isPending ? item.previewUrl : item.previewUrl;
                        const fileId = isPending ? null : item.file_id;
                        const fileName = isPending ? item.name : (item.filename || '');
                        const isLastImage = index === allImages.length - 1;
                        const removeIndex = isPending ? item.index : index;
                        
                        return (
                          <React.Fragment key={`${fieldName}-${isPending ? `pending-${removeIndex}` : (fileId || index)}`}>
                            <div className={`image-wrapper ${isPending ? 'pending-upload' : ''}`}>
                              <div className="image">
                                {isPending && <div className="pending-badge">New</div>}
                                {/* Only show remove button for partner images */}
                                {isPartnerImageField && (
                                  <button
                                    className="image-remove-btn"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleRemoveImage(fieldName, fileId, removeIndex);
                                    }}
                                    type="button"
                                    title="Remove image"
                                  >
                                    <img src={removeIcon} alt="Remove" />
                                  </button>
                                )}
                                <img
                                  src={imageUrl}
                                  alt={fileName}
                                  loading="lazy"
                                  onError={(e) => {
                                    e.target.style.display = 'none';
                                  }}
                                />
                              </div>
                            </div>
                            {/* Only show add button for partner images and only on last image */}
                            {isLastImage && isPartnerImageField && (
                              <div className="image-add-wrapper">
                                <button
                                  className="image-add-btn"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleAddImage(fieldName);
                                  }}
                                  type="button"
                                  title="Add image"
                                >
                                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <line x1="12" y1="5" x2="12" y2="19"></line>
                                    <line x1="5" y1="12" x2="19" y2="12"></line>
                                  </svg>
                                </button>
                              </div>
                            )}
                          </React.Fragment>
                        );
                      })}
                      {/* Show add button if no images exist - only for partner images */}
                      {allImages.length === 0 && isPartnerImageField && (
                        <div className="image-add-wrapper">
                          <button
                            className="image-add-btn"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleAddImage(fieldName);
                            }}
                            type="button"
                            title="Add image"
                          >
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                              <line x1="12" y1="5" x2="12" y2="19"></line>
                              <line x1="5" y1="12" x2="19" y2="12"></line>
                            </svg>
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                );
              };
              
              return (
                <>
                  {/* 4. Vedhæft billeder from Billede modtagelse - View */}
                  {renderFieldSection('vedhaeft-billeder-from-billede-modtagelse', 'Vedhæft Billeder fra Billede Modtagelse')}
                  {/* 5. Billeder fra maler inden opstart - Edit */}
                  {renderFieldSection('images-from-partners', 'Billeder fra maler inden opstart')}
                </>
              );
            })()}
          </div>
        </div>
      )}
    </>
  );
};

export default InquiryFields;

